<p-dialog
  [(visible)]="visible"
  (onHide)="closed.emit()"
  [modal]="true"
  [dismissableMask]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  appendTo="body"
  styleClass="admin-news-viewer"
>
  <ng-template #header>
    <div class="admin-news-viewer__header">
      <h3 class="admin-news-viewer__title">{{ news?.Title }}</h3>
      <span class="admin-news-viewer__meta" *ngIf="news?.PublishedOn">
        {{ "PUBLISHED_ON" | translate }}:
        {{ news?.PublishedOn | date: "dd/MM/yyyy" }}
      </span>
    </div>
  </ng-template>

  <div class="admin-news-viewer__body" *ngIf="news">
    <p-editor
      [ngModel]="news.ContentData"
      [readonly]="true"
      [modules]="{ toolbar: false }"
    ></p-editor>
  </div>

  <ng-template #footer>
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      <span translate>CLOSE</span>
    </button>
  </ng-template>
</p-dialog>
